import barba from "@barba/core";

import { replaceContent } from "./utils";
import BatchAnimation from "./../batch-animation"
export default class Navigation {
  currentBatch = null;
  constructor({ menu, callback, leaveCallback, footerScene }) {
    this.menu = menu
    this.checkParts();
    const self = this;

    barba.hooks.beforeLeave(({ next }) => {
      if (menu.isOpen) {
        const timeline = new gsap.timeline()
        timeline.add(menu.close(),'a');
      }
    });

    barba.hooks.beforeEnter(({ current, next }) => {
      self.syncStyles(next.html);
      if (next.url.path === '/' || next.url.path === '') {
        footerScene.show()
      } else {
        footerScene.hide()
      }
    });
    
    barba.hooks.afterLeave(({ next }) => {   
      gsap.set(window, { scrollTo: 0 })
      callback(next.container);

      const animatedBatch = new BatchAnimation({ el: next.container })
      gsap.from("footer.wp-block-template-part", {
        duration: .3,
        opacity: 0,
        clearProps: "all"
      });
      gsap.from(next.container, {
        duration: .3,
        opacity: 0,
        clearProps: "all",
        onComplete: () => {
          animatedBatch.apply()
        }
      });
      window.dispatchEvent(new Event('resize'));
      ScrollTrigger.refresh();

      const videos = next.container.querySelectorAll('video');

      videos.forEach(video => {
        if (video.muted && video.playsInline) 
        video.play().catch(error => {
          console.warn("Autoplay was prevented on this video:", error);
        });
      });

      requestAnimationFrame(() => {

        window.dispatchEvent(new Event('resize'));
        ScrollTrigger.refresh();
      })   
    });

    barba.init({
      debug: true,
      // Cellular connections easily exceed 5 s for a page fetch; a timeout here
      // falls back to a full reload (requestError), which is far slower.
      timeout: 20000,
      // preventRunning: true,
      sync: false,
      prevent: function ({ event, href }) {
        if (event.type === 'click') {
          const currentUrl = new URL(window.location.href);
          const destinationUrl = new URL(href, window.location.href);

          if (currentUrl.origin === destinationUrl.origin && currentUrl.pathname === destinationUrl.pathname) {
            if (menu.isOpen) {
              const timeline = new gsap.timeline()
              timeline.add(menu.close(),'a');
            }
          }
        }
        if (event.type === 'click' && href === window.location.href) {
          event.preventDefault();
          event.stopPropagation();
          return true
        } 
        return (
          href &&
          (href.includes("/wp-content/uploads/") || href.includes("/wp-admin/"))
          ) || document.body.classList.contains("error404");
        
      },
      requestError: (trigger, action, url, response) => {
        if (trigger === 'timeout' && action === 'click') {
          window.location.href = url;
          return;
        }
        
        if (action === "click" && response && response.status === 404) {
        } else {
          console.warn("requestError", trigger, action, url, response);
        }
      },
      transitions: [
        {
          name: 'default-transition',
          leave(data) {
            leaveCallback();
            
            if (menu.isOpen) {
              gsap.set(data.current.container, {
                opacity: 0
              });
              return true
            } else {
              const leaveAnimation = gsap.timeline()
              leaveAnimation.to(data.current.container, {
                duration: .3,
                opacity: 0,
                onComplete:() => {
                  gsap.set(data.current.container, {
                    display: 'none'
                  })
                }
              }, 'a');
              leaveAnimation.to("footer.wp-block-template-part", {
                duration: .3,
                opacity: 0,
              }, 'a');

              return leaveAnimation;
            }
          }
        }
      ]
    });
  }

  syncStyles(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");

    const newStyles = doc.querySelectorAll('style[id]');

    newStyles.forEach((style) => {
      if (!document.getElementById(style.id)) {
        document.head.appendChild(style.cloneNode(true));
      }
    });
  }

  checkParts() {
    let adminBar = document.body.querySelector("#wpadminbar");
    if (adminBar) {
      barba.hooks.beforeEnter(({ current, next }) => {
        if (current.container) {
          replaceContent(next, "#wpadminbar");
        }
      });
    }
  }
}